export default __webpack_public_path__ + "static/megger_logo-7dd2f217b44241105d5e641e8b3bc3e8.svg";